import { render, staticRenderFns } from "./DashboardFSOCustomerMemos.vue?vue&type=template&id=73e48ab2"
import script from "./DashboardFSOCustomerMemos.vue?vue&type=script&lang=js"
export * from "./DashboardFSOCustomerMemos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports